import React, { useContext } from "react";
import { AppContext } from "../context/app.context";

/**
 * Compass (#191) — header circle button that opens the in-app Compass data
 * browser (the MongoDB-Compass-style read-only browser for the Convex mirror
 * AND the live Mongo collections).
 *
 * Visibility:
 *   - hidden when not logged in (parent Header conditionally renders this
 *     access-gated button only when mongoUser exists; the canAccessCompass
 *     gate additionally requires the "compass" token in tsUserDocument.screenAccessList (#202))
 *   - shown on every screen (unlike Time Machine / Dashboard, Compass is an
 *     admin data tool, not tied to a schedulable concept — it stays available
 *     regardless of whichList)
 *
 * Visual: matches the circular outline style of the "?" help icon, the "🕒"
 * Time Machine button, and the "📊" Dashboard button, with a hand-held
 * magnetic compass emoji (🧭) centered.
 *
 * Click opens the full-screen browser via setOpenCompassModal({ show: true }).
 */
const CompassButton = () => {
  const { setOpenCompassModal } = useContext(AppContext);

  const handleClick = () => {
    setOpenCompassModal({ show: true });
  };

  return (
    <button
      onClick={handleClick}
      type="button"
      title="Compass — data browser"
      aria-label="Open Compass data browser"
      className="w-7 h-7 ml-4 rounded-full border-2 border-skin-link text-skin-link font-bold leading-none flex items-center justify-center hover:opacity-75"
    >
      <span aria-hidden="true">{"\u{1F9ED}"}</span>
    </button>
  );
};

export default CompassButton;
